import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    question: 'What is SuperTool AI and how does it work?',
    answer: 'SuperTool AI is an AI-powered development platform that transforms your ideas into fully functional applications. Simply describe what you want to build in natural language, and our AI agents handle the coding, design, and deployment. No programming experience required.'
  },
  {
    question: 'What can I build with SuperTool AI?',
    answer: 'You can build virtually any web or mobile application — from SaaS platforms and e-commerce stores to dashboards, social apps, booking systems, and more. Our AI agents support React frontends, Python/Node backends, databases, and third-party integrations like Stripe, OpenAI, and more.'
  },
  {
    question: 'How does SuperTool AI\'s pricing work?',
    answer: 'SuperTool AI uses a credit-based system. Each AI interaction costs credits. The Free plan gives you 10 credits per month. Standard and Pro plans include more monthly credits and additional features like priority support, custom domains, and team collaboration. You can also purchase credit packs at any time.'
  },
  {
    question: 'Do I need coding experience to use SuperTool AI?',
    answer: 'Not at all. SuperTool AI is designed for everyone — from complete beginners to experienced developers. Describe your app in plain English, and our AI builds it for you. Developers can also fine-tune the generated code directly.'
  },
  {
    question: 'How is SuperTool AI different from other no-code platforms?',
    answer: 'Unlike traditional no-code tools that limit you to drag-and-drop templates, SuperTool AI generates real, production-ready code. You get full-stack applications with custom logic, databases, and APIs. You own the code and can export, modify, or deploy it anywhere.'
  },
  {
    question: 'What happens to the code SuperTool AI creates?',
    answer: 'You own 100% of the code. Export it to GitHub, download it locally, or deploy it directly from our platform. The code is clean, well-structured, and follows modern best practices — no lock-in, no proprietary frameworks.'
  }
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div id="faq" className="py-24 bg-background" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-sm font-semibold text-muted-foreground uppercase tracking-widest mb-4">
            FREQUENTLY ASKED QUESTIONS
          </p>
          <h2 className="text-4xl sm:text-5xl font-bold text-white leading-tight">
            Curious about SuperTool AI?
            <br />
            We got you covered
          </h2>
        </div>

        <div className="space-y-0" data-testid="faq-list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border-b border-border"
              data-testid={`faq-item-${index}`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                className="w-full py-6 flex items-center justify-between text-left group"
                data-testid={`faq-toggle-${index}`}
              >
                <h3 className="text-lg font-semibold text-white group-hover:text-blue-400 transition-colors pr-8">
                  {faq.question}
                </h3>
                <ChevronDown
                  className={`w-5 h-5 text-muted-foreground transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-60 pb-6' : 'max-h-0'
                }`}
              >
                <p className="text-muted-foreground leading-relaxed text-sm">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQSection;
